import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { ApiNew } from './api-new';
import { Rule } from '../../models/rule.model';



@Injectable()
export class RuleService {

  constructor(
    private apiNew: ApiNew
  ) { }

  create(data: Rule) {
    return this.apiNew.post('rules', data);
  }
  update(id: string, data: Rule) {
    return this.apiNew.put('rules', id, data);
  }
  delete(id: string) {
    return this.apiNew.delete('rules', id);
  }
  show(id: string) {
    return this.apiNew.getOne('rules', id)
  }
  showAll(params: any = {}) {
    return this.apiNew.getAll('rules', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/rule.service.ts